import React, { useEffect, useState } from 'react';
import { Plus, X, Search, RefreshCw, Download } from 'lucide-react';
import styles from './MileageAnalysisTab_bus.module.css';
import '../style.css';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import { useVehicleData } from './context';
import Select from 'react-select'
import DownloadVehicleInfoPDF from './DownloadDriverDetails';
import BootstrapModalWrapper from '../CustomModal';



const VehicleDetailsCard = ({ /* selectedVehicles, onAddVehicle, */ filterData, /* onFilterChange, */ onVehicleSelect, /* bestDayDate,  */benchmarkType }) => {
  const [localSelectedVehicles, setLocalSelectedVehicles] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [options, setOptions] = useState([])



  const { GlobalData, setGlobalData } = useVehicleData();

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + `mileage_analysis_ace/mileage_analysis_all_vin_registration_number`,
        body: {
          filterdata: {
            ...filterData,
          }
        }
      },
      (res) => { //  { value: 'chocolate', label: 'Chocolate' },
        let data = res.map((item, index) => ({ value: item.key.vehicleId, label: item.key.vehicleId + " / " + item.key.vehicle_registration_number, regNo: item.key.vehicle_registration_number, id: index + 1 }))
        // setAllVins(data)
        setOptions(data)
      }
    );
  }, [filterData])




  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? '#358696' : '#ccc', // Blue when focused
      boxShadow: state.isFocused ? '0 0 0 1px #358696' : 'none',
      '&:hover': {
        borderColor: '#92d2d5ff'
      },
      minHeight: '38px',
      textAlign: 'left',

    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? '#d0edeaff' // Light blue on hover
        : state.isSelected
          ? '#92d5d3ff' // Blue on selected
          : 'white',
      color: state.isSelected ? 'black' : 'black',
      '&:hover': {
        backgroundColor: '#d0edeaff', // Slightly lighter blue
      },
      textAlign: 'left',
      fontSize: "12px"
    }),

    singleValue: (provided) => ({
      ...provided,
      color: '#358696', // Selected text color
      // fontWeight: 'bold',
    }),

    menu: (provided) => ({
      ...provided,
      zIndex: 9999 // Ensure it stays above modals or other components
    }),
  };

  const [vinNo1, setVinNo1] = useState()
  const [vinNo2, setVinNo2] = useState()
  const [primaryVehicle, setPrimaryVehicle] = useState({})
  const [secondaryVehicle, setSecondaryVehicle] = useState({})

  function handleChange(value) {
    setVinNo1(value)
  }
  function handleChange2(value) {
    setVinNo2(value)
  }

  function addPrimaryVehicle() {
    setPrimaryVehicle(vinNo1)
    onVehicleSelect(prev => ({ ...prev, firstVinNo: { vehicleId: vinNo1?.value }, }));
  }

  function addSecondaryVehicle() {
    setSecondaryVehicle(vinNo2)
    onVehicleSelect(prev => ({ ...prev, secondVinNo: { vehicleId: vinNo2?.value }, }));
  }
  return (
    <>
      <div className="row mb-4">
        <div className="col-12">
          <div className={`${styles.vehicleContainer} px-4`}>
            {/* Vehicle Details Row */}
            <div className="row align-items-center">
              <div className="col-3">
                <div className={`d-flex align-items-center px-2 ${styles.vehicleDetailsSection}`}>
                  <h6 className={`mb-0 ${styles.vehicleDetailsTitle}`}>
                    Vehicle Details :
                  </h6>
                </div>
              </div>

              {/* First Add Vehicle Section */}
              <div className="col-3">
                <div
                  className={`d-flex align-items-center justify-content-center px-4 position-relative ${styles.addVehicleSlot}`}
                  style={{ minHeight: '80px' }}
                >
                  {primaryVehicle?.value ? (
                    <div >
                      <small className={styles.selectedVehicleText}>
                        {primaryVehicle?.value}
                        <br />
                        {primaryVehicle?.regNo}

                      </small>
                      <div className="d-flex align-items-center justify-content-center gap-1 w-100">
                        <button
                          className={`btn btn-sm ms_btn_ace border-0 ${styles.actionButton}`}
                          data-toggle="modal" data-target={"#AddVehicle1"}
                        >
                          <RefreshCw size={14} color="#666" />
                        </button>
                        <button
                          className={`btn btn-sm ms_btn_ace border-0 ${styles.actionButton}`}
                          data-toggle="modal" data-target={"#Download_MSbus_Analysis"}
                        >
                          {/* <Download size={14} color="#666" /> */}
                          <DownloadVehicleInfoPDF />
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      className={`d-flex align-items-center ${styles.addVehicleContent}`}
                      data-toggle="modal" data-target={"#AddVehicle1"}
                    >
                      <div className={`d-flex align-items-center justify-content-center me-2 ${styles.addVehicleIcon}`}>
                        <Plus size={12} color="white" />
                      </div>
                      Add Vehicle
                    </div>
                  )}
                </div>
              </div>

              {/* Best Driven Day Parameters Section */}
              <div className="col-3">
                <div
                  className={`d-flex align-items-center justify-content-center px-4 ${styles.bestDaySection}`}
                  style={{ minHeight: '80px' }}
                >
                  <p className={`mb-0 text-muted text-center ${styles.bestDayText}`}>
                    {GlobalData?.bestVehicle
                      ? `This table represents best driven day for selected vehicle - ${GlobalData?.bestVehicle}`
                      : "Best driven day parameters for selected vehicle will appear here"
                    }
                  </p>
                </div>
              </div>

              {/* Second Add Vehicle Section */}
              <div className="col-3">
                <div
                  className={`d-flex align-items-center justify-content-center px-4 position-relative ${localSelectedVehicles[1] ? styles.selectedVehicleSlot : styles.addVehicleSlot}`}
                  style={{ minHeight: '80px' }}
                >
                  {benchmarkType == "National" ?
                    <div className=" w-100">
                      <div className={styles.selectedVehicleText} style={{ fontSize: "11px" }}>
                        {GlobalData?.nationalVehicleDetails?.vehicleId}
                      </div>
                      <div className={styles.selectedVehicleText} style={{ fontSize: "11px" }}>
                        {GlobalData?.nationalVehicleDetails?.vehicle_registration_number}
                      </div>
                    </div>
                    : <></>}
                  {benchmarkType == "Fleet" ?
                    <div className=" w-100">
                      <div className={styles.selectedVehicleText} style={{ fontSize: "11px" }}>
                        {GlobalData?.fleetVehicleDetails?.vehicleId}
                      </div>
                      <div className={styles.selectedVehicleText} style={{ fontSize: "11px" }}>
                        {GlobalData?.fleetVehicleDetails?.vehicle_registration_number}
                      </div>
                    </div>
                    : <></>}
                  {benchmarkType == "Custom" ? secondaryVehicle?.value ? (
                    <div>
                      <small className={styles.selectedVehicleText}>
                        {secondaryVehicle?.value}
                        <br />
                        {secondaryVehicle?.regNo}
                      </small>
                      <div className="d-flex align-items-center justify-content-center w-100">
                        <button
                          data-toggle="modal" data-target={"#AddVehicle2"}
                          className={`btn btn-sm ms_btn_ace border-0 ${styles.actionButton}`}
                        >
                          <RefreshCw size={14} color="#666" />
                        </button>
                      </div>
                    </div>
                  ) : (

                    <div
                      data-toggle="modal" data-target={"#AddVehicle2"}
                      className={`d-flex align-items-center ${styles.addVehicleContent}  ${!primaryVehicle?.value ? styles.disabledTab : ''} `}
                    >
                      <div className={`d-flex align-items-center justify-content-center me-2 ${styles.addVehicleIcon}`}>
                        <Plus size={12} color="white" />
                      </div>
                      Add Vehicle
                    </div>
                  ) : <></>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Popup Modal */}
      <BootstrapModalWrapper id="AddVehicle1" size="modal-md" title={"Add Vehicle"} closeBtn={false} footerClass="d-none">
        <div className="modal-body p-0"
          style={{
            overflow: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            height: "300px",
            overflowY: "scroll",
          }}
        >
          <div className='mx-3 mt-2'>
            <Select
              options={options}
              value={vinNo1}
              onChange={handleChange}
              styles={customStyles}
              placeholder="Search vehicle..."
              noOptionsMessage={() => isLoading ? "Loading..." : "No vehicles found"}
            />
          </div>
          {
            primaryVehicle.value ?
              <div className='mx-3 mt-4 card p-2 text-start'>
                <div className='text-muted fw-bold mb-2' style={{ fontSize: "12px" }}>Vehicle Details</div>
                <p className='mb-1 fw-bold'>{primaryVehicle?.value}</p>
                <p className='mb-1 fw-bold'>{primaryVehicle?.regNo}</p>
              </div>
              : <div className='mx-3 mt-4 p-2'>
                <div className='text-muted fw-bold mb-2' style={{ fontSize: "12px" }}>No Vehicle Select</div>
              </div>
          }
        </div>
        <div className="modal-footer">
          {
            vinNo1?.value ?
              <button type="button" className="btn ms_btn_ace btn-default" data-dismiss="modal" onClick={addPrimaryVehicle} >
                Add Vehicle
              </button> :
              <></>
          }

        </div>
      </BootstrapModalWrapper>

      <BootstrapModalWrapper id="AddVehicle2" size="modal-md" title={"Add Vehicle"} closeBtn={false} footerClass="d-none">
        <div className="modal-body p-0"
          style={{
            overflow: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            height: "300px",
            overflowY: "scroll",
          }}
        >
          <div className='mx-3 mt-2'>
            <Select
              options={options}
              value={vinNo2}
              onChange={handleChange2}
              styles={customStyles}
              placeholder="Search vehicle..."
            />
          </div>
          {
            secondaryVehicle?.value ?
              <div className='mx-3 mt-4 card p-2 text-start'>
                <div className='text-muted fw-bold mb-2' style={{ fontSize: "12px" }}>Vehicle Details</div>
                <p className='mb-1 fw-bold'>{primaryVehicle?.value}</p>
                <p className='mb-1 fw-bold'>{primaryVehicle?.regNo}</p>
              </div>
              : <div className='mx-3 mt-4 p-2 '>
                <div className='text-muted fw-bold mb-2' style={{ fontSize: "12px" }}>No Vehicle Select</div>
              </div>
          }
        </div>
        <div className="modal-footer">
          {
            vinNo2?.value ?
              <button type="button" className="btn ms_btn_ace btn-default" data-dismiss="modal" onClick={addSecondaryVehicle} >
                Add Vehicle
              </button> : <></>
          }

        </div>
      </BootstrapModalWrapper>
    </>
  );
};

export default VehicleDetailsCard;